import React, { useEffect } from 'react';
import ProfileImage from '../assets/image/me.png';
import '../styles/Resume.css';

import { get_Experience, get_Education, get_Skill, get_Certificate, get_QA } from '../utils/resumeDataUtils';
import { work_experience, education, skillData, certificationsData, qaData } from '../data/data';
import { setupCollapsibles } from "../utils/setupCollapsibles";

const Resume: React.FC = () => {
  useEffect(() => {
    get_Experience(work_experience);
    get_Education(education);
    get_Skill(skillData);
    get_Certificate(certificationsData);
    get_QA(qaData);
    
    setTimeout(() => {
      setupCollapsibles();
    }, 100); // Delay to ensures collapsible buttons exist
  }, []);

  return (
    <div>
    <section className="about fade-transition">
        <div className="about--info py-2">
            <div className="about--image">
                <img 
                    src={ProfileImage} 
                    className="profile-image" 
                    alt="Profile image"
                    loading="lazy" />
            </div>
            <div>
                <h1 className="primary-color bold fs-xlarge text-shadow">Bello Ibrahim</h1>
                <small className="gray d-block fs-sm text-center">Nigeria</small>
            </div>
        </div>
        <div className="about--objective">
            <h1 className="primary-color bold">Professional Summary:</h1>
            <p> 
                Results-driven IT professional with 10+ years of hands-on-experience in technical support, web development, and IT service delivery. Founder of An-Nur Info. Tech., passionate about creating solutions, mentoring beginners, and delivering client-focused systems using modern frameworks like laravel, Flask, Django, and React.
            </p>
        </div>
        <div className="about--contact">
            <div className="item">
                <a href="mailto:b.ibrahim@an-nur-info-tech.com" title="Email" target="_blank" rel="noopener noreferrer"><p><i className="fas fa-envelope"></i>&nbsp; b.ibrahim@an-nur-info-tech.com</p></a>
            </div>
            <div className="item">
                <p title="Mobile contact"><i className="fas fa-phone"></i> &nbsp;+234 8137541749</p>
            </div>
            <div className="item">
                <a href="https://youtube.com/@an-nurinfo-tech.7119" title="Youtube Page" target="_blank" rel="noopener noreferrer"><p><i className="fab fa-youtube"></i></p></a>
            </div>
            <div className="item">
                <a href="https://an-nur-info-tech.com" title="Website" target="_blank" rel="noopener noreferrer"><p><i className="fas fa-globe"></i></p></a>
            </div>
            <div className="item">
                <a href="https://www.linkedin.com/in/bello-ibrahim-9b7979259" title="Linkedin profile" target="_blank" rel="noopener noreferrer"><p><i className="fab fa-linkedin"></i></p></a>
            </div>
            <div className="item">
                <a href="https://wa.me/message/Y3BQG6SHQEZRA1" title="Whatsapp" target="_blank" rel="noopener noreferrer"><p><i className="fab fa-whatsapp"></i></p></a>
            </div>
            <div className="item">
                <a href="https://github.com/Bello-Ibrahm" title="Github" target="_blank" rel="noopener noreferrer"><p><i className="fab fa-github"></i></p></a>
            </div>
        </div>
    </section>

    <section className="experience" id="experience">
        <h1 className="primary-color bold py-1"><i className="fas fa-briefcase primary-color"></i> &nbsp;Work Experience</h1>
        <div id="experienceItem"></div>
        {/* Template
        <div className="section-item p-relative">
            <div className="head-ball"></div>
            <small className="gray"> January 2022 - July 2023</small>
            <h3 className="secondary-color">Crest-Agro Products</h3>
            <p>IT Officer</p>
        </div> */}
    </section>

    <section className="education" id="education">
        <h1 className="primary-color bold py-1"><i className="fas fa-graduation-cap primary-color"></i> &nbsp;Education</h1> 
        <div id="educationItem"></div>
        {/* DATA IS FETCHED FROM THE data.js file  */}
    </section>

    <section className="skills" id="skills">
        <h1 className="primary-color bold py-1"><i className="fas fa-cogs primary-color"></i> &nbsp;Skills</h1> 
        <div className="flex-row" id="skillData">
            {/* Template
            <div className="skill-item">
                <h3 className="">PHP: </h3>
                <i className="fas fa-star secondary-color"></i>
                <i className="fas fa-star secondary-color"></i>
                <i className="fas fa-star secondary-color"></i>
                <i className="fas fa-star secondary-color"></i>
                <i className="fas fa-star"></i>
            </div> */}
        </div> 
    </section>
    
    <section className="certification" id="certification">
        <h1 className="primary-color bold py-1"><i className="fas fa-certificate primary-color"></i> &nbsp; Certifications / Awards </h1> 
        <div className="certification-items" id="certificateItem">
            {/* <div className="section-item p-relative">
                <div className="head-ball"></div>
                <small className="gray">Coding to 6 Figures Program (2023)</small>
                <h3 className="bold secondary-color"><i className="fas fa-trophy primary-color"></i> Blakio LLC</h3>
                <a href="https://www.blakio.com" target="_blank" className="gray">www.blakio.com</a>
            </div>  */}
        </div>
    </section>
    
    <section className="qa" id="qa">
        <h1 className="primary-color bold py-1"><i className="fas fa-question-circle primary-color"></i> &nbsp; Q & A </h1> 
        <div className="collapse-content" id="qa-content">
            {/* Template 
                <div>
                <button className="collapsible">Are you legally authorized to work in the US?</button>
                <div className="content-collapse">
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                </div>
            </div>
            */}
        </div>
    </section>

    </div>
  );
};

export default Resume;